import { QueryList } from '@angular/core';
import { FocusableOption, FocusKeyManager } from '@angular/cdk/a11y';

export type ElFocusableOption = FocusableOption;
export class ElFocusKeyManager<T> extends FocusKeyManager<T> {}

export class ElFocusKeyManagerFactoryService<T extends ElFocusableOption> {
  create(items: QueryList<T> | T[]): ElFocusKeyManager<T> {
    return new ElFocusKeyManager<T>(items);
  }
}
